const messages = {
  buttons: {
    productBrochures: "Scopri",
  },
  index: {
    title: "Informazioni sul prodotto",
    description:
      "Benvenuti nell'area informativa sui prodotti Bridgestone e Firestone. Qui troverete brochure aggiornate e materiale aggiuntivo.",
    categories: {
      productBrochures: {
        title: "Brochure dei prodotti",
        description:
          "Scarica le ultime brochure dei prodotti Bridgestone e Firestone",
      },
      bDrive: {
        title: "Immagini di pneumatici e loghi",
        description:
          "Loghi, immagini dei prodotti e modelli di marketing attuali",
        button: "PER B-DRIVE",
      },
    
      kickback: {
        description: "Alle aziende partecipanti vengono accreditate le commissioni kickback in base ai dati di vendita trasmessi.",
      },
    },
  },
};

export default {
  messages,
};
